module.exports = __webpack_public_path__ + "static/img/profile.90bc1cf6.jpg";